import { Helmet, HelmetProvider } from "react-helmet-async";

export const ILHead = ({ title, children }) => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{title} | Ilonsi</title>
        {children}
      </Helmet>
    </HelmetProvider>
  );
};
